module.exports = __webpack_public_path__ + "slider-left-arrow.svg?9489cf07510d8780d6bb372cff9b4732";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-left-arrow.svg
// module id = 143
// module chunks = 0